import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Ghost } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/compte");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="login-page">
      <div className="text-center mb-8">
        <Ghost className="h-10 w-10 text-amber-500 mx-auto mb-3" />
        <h1 className="font-display text-3xl font-black text-stone-100">Connexion</h1>
        <p className="text-stone-400 text-sm mt-2">Retrouvez vos commandes et vos favoris.</p>
      </div>
      <form onSubmit={submit} className="gothic-card rounded-2xl p-8 space-y-5">
        {error && <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-3" data-testid="login-error">{error}</p>}
        <div>
          <label className="block text-sm text-stone-400 mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
            className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
        </div>
        <div>
          <label className="block text-sm text-stone-400 mb-2">Mot de passe</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
            className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="btn-ember rounded-xl w-full py-3.5 disabled:opacity-60">
          {loading ? "Connexion…" : "Se connecter"}
        </button>
        <p className="text-center text-sm text-stone-400">
          Pas encore de compte ? <Link to="/inscription" className="text-amber-400 hover:underline">Créer un compte</Link>
        </p>
      </form>
    </div>
  );
}
